import { apiClient } from '@/lib/api-client'

export interface JobSummary {
  id: number
  trace_id: string
  kind: string
  status: 'running' | 'ok' | 'error' | 'cancelled'
  document_title: string
  model: string
  result: string
  error: string
  llm_calls: number
  duration_ms: number | null
  started_at: string | null
  document_id: number | null
}

export interface JobDetail extends JobSummary {
  prompt: string
  input_sample: string
  output_sample: string
  finished_at: string | null
}

export async function getJobs(limit = 100): Promise<JobSummary[]> {
  const { data } = await apiClient.get<{ jobs: JobSummary[] }>('/jobs', { params: { limit } })
  return data.jobs ?? []
}

export async function getJob(id: number): Promise<JobDetail> {
  const { data } = await apiClient.get<JobDetail>(`/jobs/${id}`)
  return data
}
